import React from "react";
import { Navigate } from "react-router-dom";
import { useReviewsAccess } from "../hooks/useReviewsAccess";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import NotFoundPage from "../pages/NotFound";

interface ReviewsProtectedRouteProps {
    children: JSX.Element;
    isLoggedIn: boolean;
}

/**
 * Protected route for Reviews:
 * - User is logged in
 * - User is Rewind owner OR company has the reviews addon
 */
const ReviewsProtectedRoute: React.FC<ReviewsProtectedRouteProps> = ({ children, isLoggedIn }) => {
    const { hasAccess, loading } = useReviewsAccess();

    if (loading) {
        return <LoadingSpinner size={50} />;
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (!hasAccess) {
        return <NotFoundPage />;
    }

    return children;
};

export default ReviewsProtectedRoute;
